module.exports = __webpack_public_path__ + "img/10coin.a4e37bf5.png";